define(['angular'], function(angular) {


    /**
     * @class FleuristeService
     */
    function FleuristeService(userService, pricesService) {
        var self = this;

        return self;
    }

    FleuristeService.$inject = ['userService', 'pricesService'];

    angular.module('app.bdc.common.fleuristeService', []).factory('fleuristeService', FleuristeService);
});
